module.exports = "<div class=\"ui-g dashboard\" *ngIf=\"dashboardData\" style=\"width: 100%;\">\n  <div class=\"ui-g-12 card\">\n    <p-panel header=\"Data Charts\">\n      <div class=\"chart chart-align\">\n        <p-chart type=\"line\" [data]=\"dataUsage\" [options]=\"chartOptions\" responsive=\"true\" class=\"ui-g-12\"></p-chart>\n      </div>\n    </p-panel>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/usage_statistics/data/data.component.html
// module id = ../../../../../src/app/components/usage_statistics/data/data.component.html
// module chunks = main